import { LandingResponse } from '@/modules/contents/web.interface';
import styles from './landing-footer.module.less';

export default function Faq({
  landingData,
  handleToTop,
}: {
  landingData: LandingResponse;
  handleToTop: () => void;
}) {
  const { contentInfo } = landingData;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          {/* Text Content */}
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              {contentInfo['section-cta'].title}
            </h2>
            <p className={styles.description}>
              {contentInfo['section-cta'].desc}
            </p>
          </div>

          {/* CTA Button */}
          <button
            className={styles.ctaButton}
            onClick={handleToTop}
          >
            {contentInfo['section-cta'].buttonText}
          </button>
        </div>
      </div>
    </section>
  );
}
